
export const locale = {
  'DIALOG': {
    'CARRIER': {
      'TITLE': {
        'CREATE': 'Create carrier',
        'EDIT': 'Edit carrier',
      },
      'CONFIRMBUTTON': {
        'CREATE': 'Create',
        'SAVE': 'Save',
      },
      'PICK_COLOR': 'Pick mark color',
      'FULLNAME': 'Name',
      'LIMITATIONS': {
        'TITLE': 'Ограничения',
        'MESSAGE': "Set permissions for order actions for '{{value}}'?",
        'SAVE': 'Save',
        'CREATE': 'Allow order creation',
        'EDIT': 'Allow order editing',
        'SALE_PRICE': 'Can see sale price',
        'RESERVE': 'Can reserve proposals',
        'LIST': {
          'ALLOW_MESSAGE': 'Allow carrier to see',
          'CUSTOMERS': 'Limit customers',
          'SUPPLIERS': 'Limit suppliers',
          'STYLE': {
            'ALL': 'All',
            'LIST': 'List',
            'NONE': 'None',
          },
        },
      },
    },
  },
};
